// extracted by mini-css-extract-plugin
export default {"main":"uvtiKIDFjsurjjGI1tH0","title":"CGGlbAhH2qIKwA34EZBZ","name":"S2wioqM_mhJVSdYMHXnj","commissionNumber":"ryOmGYfzifhSlHZgnymr","grayScale":"imIlRWk30VtDMBVDu2m4"};